export enum ReturnCodesFilterContextActionType {
  ORDER = 'ORDER',
  RESTAURANTS = 'RESTAURANTS',
  DATE = 'DATE',
  STATUS = 'STATUS',
}
